// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * SUREnet overig API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfSUREbusinessManagementRecenteActiviteitenGetStatustellersDto } from '../model/collectionResultOfSUREbusinessManagementRecenteActiviteitenGetStatustellersDto';

import type { CollectionResultOfSUREbusinessManagementRecenteActiviteitenRecenteActiviteitenRecenteActiviteitItemDto } from '../model/collectionResultOfSUREbusinessManagementRecenteActiviteitenRecenteActiviteitenRecenteActiviteitItemDto';

import type { RecenteActiviteitenCountParams } from '../model/recenteActiviteitenCountParams';

import type { RecenteActiviteitenGetParams } from '../model/recenteActiviteitenGetParams';

import type { RecenteActiviteitenGetStatussenParams } from '../model/recenteActiviteitenGetStatussenParams';

import type { Result1OfSUREbusinessManagementRecenteActiviteitenGetMenuTellingenDto } from '../model/result1OfSUREbusinessManagementRecenteActiviteitenGetMenuTellingenDto';

import type { Result1OfSystemInt32 } from '../model/result1OfSystemInt32';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: RecenteActiviteiten.Inzien</li></ul>
 */
export const recenteActiviteitenGet = (
  params?: MaybeRef<RecenteActiviteitenGetParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfSUREbusinessManagementRecenteActiviteitenRecenteActiviteitenRecenteActiviteitItemDto>(
    { url: `/api/v1/recente-activiteiten`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getRecenteActiviteitenGetQueryKey = (
  params?: MaybeRef<RecenteActiviteitenGetParams>,
) => {
  return ['api', 'v1', 'recente-activiteiten', ...(params ? [params] : [])] as const;
};

export const getRecenteActiviteitenGetQueryOptions = <
  TData = Awaited<ReturnType<typeof recenteActiviteitenGet>>,
  TError = ErrorType<null | null>,
>(
  params?: MaybeRef<RecenteActiviteitenGetParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRecenteActiviteitenGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recenteActiviteitenGet>>> = ({ signal }) =>
    recenteActiviteitenGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recenteActiviteitenGet>>,
    TError,
    TData
  >;
};

export type RecenteActiviteitenGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof recenteActiviteitenGet>>
>;
export type RecenteActiviteitenGetQueryError = ErrorType<null | null>;

export function useRecenteActiviteitenGet<
  TData = Awaited<ReturnType<typeof recenteActiviteitenGet>>,
  TError = ErrorType<null | null>,
>(
  params?: MaybeRef<RecenteActiviteitenGetParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRecenteActiviteitenGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: RecenteActiviteiten.Inzien</li></ul>
 */
export const recenteActiviteitenCount = (
  params?: MaybeRef<RecenteActiviteitenCountParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<Result1OfSystemInt32>(
    { url: `/api/v1/recente-activiteiten/count`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getRecenteActiviteitenCountQueryKey = (
  params?: MaybeRef<RecenteActiviteitenCountParams>,
) => {
  return ['api', 'v1', 'recente-activiteiten', 'count', ...(params ? [params] : [])] as const;
};

export const getRecenteActiviteitenCountQueryOptions = <
  TData = Awaited<ReturnType<typeof recenteActiviteitenCount>>,
  TError = ErrorType<null | null>,
>(
  params?: MaybeRef<RecenteActiviteitenCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenCount>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRecenteActiviteitenCountQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recenteActiviteitenCount>>> = ({
    signal,
  }) => recenteActiviteitenCount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recenteActiviteitenCount>>,
    TError,
    TData
  >;
};

export type RecenteActiviteitenCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof recenteActiviteitenCount>>
>;
export type RecenteActiviteitenCountQueryError = ErrorType<null | null>;

export function useRecenteActiviteitenCount<
  TData = Awaited<ReturnType<typeof recenteActiviteitenCount>>,
  TError = ErrorType<null | null>,
>(
  params?: MaybeRef<RecenteActiviteitenCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenCount>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRecenteActiviteitenCountQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: RecenteActiviteiten.Inzien</li></ul>
 */
export const recenteActiviteitenGetStatussen = (
  params?: MaybeRef<RecenteActiviteitenGetStatussenParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfSUREbusinessManagementRecenteActiviteitenGetStatustellersDto>(
    {
      url: `/api/v1/RecenteActiviteiten/statustellers`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getRecenteActiviteitenGetStatussenQueryKey = (
  params?: MaybeRef<RecenteActiviteitenGetStatussenParams>,
) => {
  return [
    'api',
    'v1',
    'RecenteActiviteiten',
    'statustellers',
    ...(params ? [params] : []),
  ] as const;
};

export const getRecenteActiviteitenGetStatussenQueryOptions = <
  TData = Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>,
  TError = ErrorType<null | null>,
>(
  params?: MaybeRef<RecenteActiviteitenGetStatussenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRecenteActiviteitenGetStatussenQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>> = ({
    signal,
  }) => recenteActiviteitenGetStatussen(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>,
    TError,
    TData
  >;
};

export type RecenteActiviteitenGetStatussenQueryResult = NonNullable<
  Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>
>;
export type RecenteActiviteitenGetStatussenQueryError = ErrorType<null | null>;

export function useRecenteActiviteitenGetStatussen<
  TData = Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>,
  TError = ErrorType<null | null>,
>(
  params?: MaybeRef<RecenteActiviteitenGetStatussenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRecenteActiviteitenGetStatussenQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: RecenteActiviteiten.Inzien</li></ul>
 * @summary Haalt tellingen voor de menu badges op uit recente activiteiten
 */
export const recenteActiviteitenGetTellingen = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Result1OfSUREbusinessManagementRecenteActiviteitenGetMenuTellingenDto>(
    { url: `/api/v1/recente-activiteiten/tellingen`, method: 'GET', signal },
    options,
  );
};

export const getRecenteActiviteitenGetTellingenQueryKey = () => {
  return ['api', 'v1', 'recente-activiteiten', 'tellingen'] as const;
};

export const getRecenteActiviteitenGetTellingenQueryOptions = <
  TData = Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>,
  TError = ErrorType<null | null>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRecenteActiviteitenGetTellingenQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>> = ({
    signal,
  }) => recenteActiviteitenGetTellingen(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>,
    TError,
    TData
  >;
};

export type RecenteActiviteitenGetTellingenQueryResult = NonNullable<
  Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>
>;
export type RecenteActiviteitenGetTellingenQueryError = ErrorType<null | null>;

/**
 * @summary Haalt tellingen voor de menu badges op uit recente activiteiten
 */

export function useRecenteActiviteitenGetTellingen<
  TData = Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>,
  TError = ErrorType<null | null>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRecenteActiviteitenGetTellingenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
